import { Modal } from '@shopify/polaris';
import { CircularProgress } from '@material-ui/core';

function PopUp({ open, closePopUp, onConfirm, children, loading }) {
  const loadingStyle = {
    textAlign: "center",
    margin: "0 auto",
    color: "#fff",
  };

  return (
    <Modal
      open={open}
      onClose={closePopUp}
      title="Preview & Confirm"
      primaryAction={{
        content: loading ? <CircularProgress size={24} style={loadingStyle} /> : 'Confirm',
        onAction: onConfirm,
        disabled: loading,
      }}
      secondaryActions={[
        {
          content: 'Close',
          onAction: closePopUp,
          disabled: loading,
        },
      ]}
    >
      <div style={{ padding: '16px' }}>
        {children}
      </div>
    </Modal>
  );
}

export default PopUp;